<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div :model="dataForm" class="whiteForm">
      <!-- <van-row>
        <van-col span="6">国家</van-col>
        <van-col span="18" class="input">
          <input v-model="country" placeholder="请选择国家" readonly unselectable="on" @click="selectCountry">
        </van-col>
      </van-row> -->
      <van-row>
        <van-col span="6">姓名</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.name" placeholder="收货人姓名">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">电话</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.phone" placeholder="收货人手机号">
        </van-col>
      </van-row>
      <van-row v-if="dataForm.country=='CHN'">
        <van-col span="6">地区</van-col>
        <van-col span="18" class="input">
          <input v-model="zip" placeholder="选择省/市/区" readonly unselectable="on" @click="selectArea">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">详细地址</van-col>
        <van-col span="18" class="input">
          <input v-model="dataForm.address" placeholder="街道门牌、楼层房间号等信息">
        </van-col>
      </van-row>
      <van-row>
        <van-col span="6">设为默认</van-col>
        <van-col span="18" style="text-align:right;">
          <van-switch
            v-model="dataForm.isDefault"
          />
        </van-col>
      </van-row>
      <br>
      <p><van-button type="info" size="large" :loading="editAddressLoading" loading-text="保存中..." @click="editAddress">保存</van-button></p>

      <p><van-button v-if="dataForm.addressId" type="info" plain size="large" :loading="deleteAddressLoading" loading-text="删除中..." @click="deleteAddress">删除</van-button></p>
      <van-popup v-model="showCountrySelect" position="bottom">
        <van-picker ref="pickerCountry" show-toolbar title="选择国家" :columns="listCountry" @cancel="onCancelPicker" @confirm="onCountry" />
      </van-popup>
      <van-popup v-model="showAreaSelect" position="bottom">
        <van-area ref="pickerArea" :value="dataForm.zip==undefined?'110000':dataForm.zip.toString()" :loading="arealoading" :area-list="areaData" @confirm="confirmArea" @cancel="onCancelPicker" />
      </van-popup>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { getUrlKey, MyNotify, initPage } from '@/utils/base'
import { Button, Popup, Picker, Switch, Area, Dialog } from 'vant'
import commonData from '@/commondata.js'
export default {
  components: {
    [Button.name]: Button,
    [Switch.name]: Switch,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Area.name]: Area,
    [Dialog.name]: Dialog,
    TopBar
  },
  data() {
    return {
      title: '地址编辑',
      backurl: '/store/addressList',
      showCountrySelect: false,
      showAreaSelect: false,
      editAddressLoading: false,
      deleteAddressLoading: false,
      listCountry: [],
      areaData: undefined,
      arealoading: false,
      dataForm: {
        addressId: undefined,
        country: 'CHN',
        zip: undefined,
        address: undefined,
        name: undefined,
        phone: undefined,
        phoneCountry: '86',
        isDefault: false
      },
      country: undefined,
      zip: undefined
    }
  },
  created() {
    initPage(false)
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = '/store/addressList?backurl' + url
    }
    // 读取数据
    var addressId = getUrlKey('addressId')
    if (addressId !== null) {
      this.dataForm.addressId = addressId
      request({
        url: '/Store/getUserAddress',
        method: 'post',
        params: { addressId: addressId }
      }).then(Response => {
        if (Response.success) {
          this.dataForm = Response.data
          this.zip = this.dataForm.zipString
          this.loadSelectData()
        }
      })
    } else {
      this.dataForm.addressId = undefined
      request({
        url: '/user/Login',
        method: 'post'
      }).then(Response => {
        if (Response.success) {
          this.loadSelectData()
        }
      })
    }
  },
  methods: {
    loadSelectData() {
      this.listCountry = []
      commonData.ssiBase.COUNTRIES.forEach(item => {
        this.listCountry.push({
          text: item.country,
          value: item.iso3
        })
      })
      if (this.dataForm.country != null) {
        this.country = this.listCountry.find(item => item.value === this.dataForm.country.toUpperCase()).text
      }
    },
    editAddress() {
      this.editAddressLoading = true
      request({
        url: '/Store/updateAddress',
        method: 'post',
        data: this.dataForm
      }).then(Response => {
        this.editAddressLoading = false
        if (Response.success) {
          MyNotify('success', '保存地址成功', 2000)
          this.$router.replace(this.backurl)
        }
      })
    },
    deleteAddress() {
      Dialog.confirm({
        title: '删除地址',
        message: '是否要删除这条地址数据',
        cancelButtonText: '取消',
        confirmButtonText: '删除'
      }).then(() => {
        this.deleteAddressLoading = true
        request({
          url: '/Store/deleteAddress',
          method: 'post',
          params: { addressId: this.dataForm.addressId }
        }).then(Response => {
          this.deleteAddressLoading = false
          if (Response.success) {
            MyNotify('success', '删除地址成功', 2000)
            this.$router.replace(this.backurl)
          }
        })
      })
    },
    onCancelPicker() {
      this.showAreaSelect = false
      this.showCountrySelect = false
    },
    onCountry() {
      var select = this.$refs.pickerCountry.getValues()
      if (select.length > 0) {
        this.country = select[0].text
        this.dataForm.country = select[0].value
      }
      this.showCountrySelect = false
    },
    selectCountry() {
      this.showCountrySelect = true
      setTimeout(() => {
        if (this.dataForm.country != null) {
          var index2 = this.listCountry.findIndex(item => item.value === this.dataForm.country.toUpperCase())
          this.$refs.pickerCountry.setIndexes([index2])
        }
      }, 1)
    },
    confirmArea(selectList) {
      var title = ''
      var zipId = 0
      selectList.forEach(item => {
        title += item.name + ' '
        zipId = item.code
      })
      this.zip = title
      this.dataForm.zip = zipId
      this.showAreaSelect = false
    },
    selectArea() {
      this.showAreaSelect = true
      this.readAreaData()
    },
    readAreaData() {
      if (this.areaData !== undefined) {
        return
      }
      this.arealoading = true
      request({
        url: '/data/getArea',
        method: 'post'
      }).then(Response => {
        this.areaData = Response
        this.arealoading = false
      })
    }
  }
}
</script>

